import { Flex, usePortal } from '@talos/kyoko';
// import { appNotificationsSliceActions } from '@src/providers/AppNotifications/redux/AppNotificationsSlice';
// import { useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { MobilePowerSearch } from 'components/Mobile/MobilePowerSearch/MobilePowerSearch';
// import { useMobileModal } from '@src/providers/MobileModalProvider';
// import { selectActiveNotificationCount } from '@src/providers/AppNotifications/redux/selectors';
// import { useAppStateDispatch } from '@src/providers/AppStateProvider';
import { ToolbarButtonWrapper, ToolbarWrapper } from './styles';

export const MOBILE_HEADER_TOOLBAR_PORTAL = 'mobile-header-toolbar-portal';
export const MOBILE_HEADER_TITLE_PORTAL = 'mobile-header-title-portal';

// const { openInbox } = appNotificationsSliceActions;

export function MobileHeader() {
  const { setPortalRef: setToolbarPortalRef } = usePortal(MOBILE_HEADER_TOOLBAR_PORTAL);
  const { setPortalRef: setTitlePortalRef } = usePortal(MOBILE_HEADER_TITLE_PORTAL);
  // const dispatch = useAppStateDispatch();
  // const { openModal, closeModal } = useMobileModal();

  // const showBackButton = false;

  // const navigate = useNavigate();

  // const handleBackButtonClick = useCallback(() => {
  //   navigate(routeMatches?.at(-2)?.pathname ?? '/');
  // }, [navigate, routeMatches]);

  // const handleOpenPowerSearch = useCallback(() => {
  //   openModal({
  //     content: <MobilePowerSearch onClose={closeModal} />,
  //   });
  // }, [openModal, closeModal]);

  // const handleOpenNotifications = useCallback(() => {
  //   dispatch(openInbox());
  // }, [dispatch]);

  // const handleOpenProfile = useCallback(() => {
  //   openModal({
  //     content: <>Profile</>,
  //   });
  // }, [openModal]);

  // const activeNotificationsCount = useAppStateSelector(selectActiveNotificationCount) ?? 0;

  return (
    <ToolbarWrapper>
      {/* {showBackButton ? (
        <ToolbarButtonWrapper>
          <MobileIconButton icon={IconName.ChevronLeft} onClick={handleBackButtonClick} />
        </ToolbarButtonWrapper>
      ) : (
        null
      )} */}
      <Flex alignItems="center" ref={setTitlePortalRef} />
      <Flex ml="auto" gap="spacing10">
        <ToolbarButtonWrapper ref={setToolbarPortalRef} />
        {/* <ToolbarButtonWrapper>
          <MobileIconButton icon={IconName.Search} onClick={handleOpenPowerSearch} />
          <IndicatorDotWrapper
            show={activeNotificationsCount > 0}
            variant={IndicatorDotVariants.Notification}
            inset={8}
          >
            <MobileIconButton icon={IconName.Bell} onClick={handleOpenNotifications} />
          </IndicatorDotWrapper>
        </ToolbarButtonWrapper> */}
      </Flex>
    </ToolbarWrapper>
  );
}
